import { gql } from '../../../../../hooks'

export const GET_RECEIVED_SAMPLE_INFO = gql`
  query GetReceivedSampleInfo($id: ID!) {
    t3ReceivedSampleInfo(id: $id) {
    }
  }
`
